import { Send } from 'lucide-react';
import { Popover, PopoverContent, PopoverAnchor } from '@/components/ui/popover.jsx';
import { ACTIVE_STAGES, TERMINAL_STAGES } from '@/services/pipeline.service.js';

// DEAL-LIFECYCLE-SPEC Phase 1: lifecycle state is DERIVED from ground truth
// (services/deal-state.service.js). The only manual moves are the terminal
// states, each requiring a typed reason. Everything else — Presented,
// Binding, Bound — is written by the deal-state mirror when the underlying
// facts change (quote presented, payment settled, placement recorded).

const BACKEND_ALLOWED = new Set([
  'Lost',
  'Expired',
  'Cancelled',
]);

const STAGE_ORDER = [...ACTIVE_STAGES, ...TERMINAL_STAGES];

function backwardMove(from, to) {
  const ai = STAGE_ORDER.indexOf(from);
  const bi = STAGE_ORDER.indexOf(to);
  if (ai === -1 || bi === -1) return false;
  return bi < ai && !TERMINAL_STAGES.includes(to);
}

export default function MoveToMenu({ open, anchorPosition, fromStage, onSelect, onCompose, onClose }) {
  if (!open) return null;
  const targets = STAGE_ORDER.filter((s) => s !== fromStage && BACKEND_ALLOWED.has(s));
  const style = anchorPosition
    ? {
        position: 'fixed',
        left: anchorPosition.x,
        top: anchorPosition.y,
        width: 1,
        height: 1,
        pointerEvents: 'none',
      }
    : undefined;
  return (
    <Popover open={open} onOpenChange={(o) => !o && onClose?.()}>
      <PopoverAnchor asChild>
        <div style={style} />
      </PopoverAnchor>
      <PopoverContent align="start" side="bottom" sideOffset={4} className="w-56 p-1">
        {onCompose ? (
          <>
            <button
              type="button"
              onClick={onCompose}
              className="flex w-full items-center gap-2 rounded-card px-2 py-1.5 text-left text-sm text-text hover:bg-border/40"
            >
              <Send size={14} strokeWidth={1.5} className="text-text-dim" />
              <span>Send email…</span>
            </button>
            <div className="my-1 border-t border-border" />
          </>
        ) : null}
        <div className="px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-text-dim">
          Move to
        </div>
        <ul className="max-h-64 overflow-y-auto">
          {targets.map((stage) => {
            const isTerminal = TERMINAL_STAGES.includes(stage);
            const isBackward = backwardMove(fromStage, stage);
            return (
              <li key={stage}>
                <button
                  type="button"
                  onClick={() => onSelect(stage)}
                  className="flex w-full items-center justify-between rounded-card px-2 py-1.5 text-left text-sm text-text hover:bg-border/40"
                >
                  <span>{stage}</span>
                  {isTerminal ? (
                    <span className="text-[10px] uppercase tracking-wide text-text-dim">
                      close
                    </span>
                  ) : isBackward ? (
                    <span className="text-[10px] uppercase tracking-wide text-text-dim">
                      back
                    </span>
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      </PopoverContent>
    </Popover>
  );
}
